<template>
      <div class="top_slider_box">
      <el-carousel indicator-position="none" :autoplay="false" class="top_slider">
        <el-carousel-item v-for="(item,index) in imgList" :key="index">
          <a :href="item.linkUrl"><img :src="item.pcUrl" alt=""></a>
        </el-carousel-item>
      </el-carousel>
    </div>
</template>

<script>
import { getBanner } from '@/service/api.js'
export default {
  data() {
    return {
      imgList: [],
    }
  },
  mounted () {
    getBanner().then((data) => {
      this.imgList = data.data
    });
  },
}

</script>

<style lang="less">
.top_slider {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  height: 386px;
  .el-carousel__item {
    height: 386px;
  }
}
</style>